export default __webpack_public_path__ + "static/media/shop.86ff95da.png";